import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed, onMounted, ref } from 'vue';
import { useAcceptCompanyInviteMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'accept',
  setup: function setup(__props) {
    var route = useRoute();
    var router = useRouter();
    var _useNuxtApp = useNuxtApp(),
      $auth = _useNuxtApp.$auth;
    var loading = ref(true);
    var errorMessage = ref('');
    var successMessage = ref('');
    var accountId = ref(null);
    var _useAcceptCompanyInvi = useAcceptCompanyInviteMutation(),
      acceptInvite = _useAcceptCompanyInvi.mutate;
    var title = computed(function () {
      return errorMessage.value ? 'Invite could not be accepted' : 'Join company account';
    });
    var continueTo = computed(function () {
      return accountId.value ? "/".concat(accountId.value, "/company") : '/';
    });
    var waitForAuthReady = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var attempt;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              attempt = 0;
            case 1:
              if (!(attempt < 40)) {
                _context.next = 9;
                break;
              }
              if ($auth.loading) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              _context.next = 6;
              return new Promise(function (resolve) {
                return window.setTimeout(resolve, 50);
              });
            case 6:
              attempt += 1;
              _context.next = 1;
              break;
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function waitForAuthReady() {
        return _ref.apply(this, arguments);
      };
    }();
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var token, _response$data, response, result, _err$graphQLErrors, _err$graphQLErrors$;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return waitForAuthReady();
          case 2:
            token = String(route.query.token || '').trim();
            if (token) {
              _context2.next = 7;
              break;
            }
            loading.value = false;
            errorMessage.value = 'This invite link is missing a token.';
            return _context2.abrupt("return");
          case 7:
            if ($auth.loggedIn) {
              _context2.next = 11;
              break;
            }
            // Auth middleware / Apollo redirect should send them to login and back here.
            loading.value = false;
            errorMessage.value = 'Please sign in with the invited email to continue.';
            return _context2.abrupt("return");
          case 11:
            _context2.prev = 11;
            _context2.next = 14;
            return acceptInvite({
              token: token
            });
          case 14:
            response = _context2.sent;
            result = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.acceptCompanyInvite;
            if (result !== null && result !== void 0 && result.success) {
              _context2.next = 19;
              break;
            }
            errorMessage.value = (result === null || result === void 0 ? void 0 : result.message) || 'Unable to accept this invite.';
            return _context2.abrupt("return");
          case 19:
            successMessage.value = result.message || 'You have joined the company account.';
            accountId.value = result.accountId ? String(result.accountId) : null;
            if (!accountId.value) {
              _context2.next = 24;
              break;
            }
            _context2.next = 24;
            return router.replace("/".concat(accountId.value, "/company"));
          case 24:
            _context2.next = 29;
            break;
          case 26:
            _context2.prev = 26;
            _context2.t0 = _context2["catch"](11);
            errorMessage.value = (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : (_err$graphQLErrors = _context2.t0.graphQLErrors) === null || _err$graphQLErrors === void 0 ? void 0 : (_err$graphQLErrors$ = _err$graphQLErrors[0]) === null || _err$graphQLErrors$ === void 0 ? void 0 : _err$graphQLErrors$.message) || (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message) || 'Unable to accept this invite.';
          case 29:
            _context2.prev = 29;
            loading.value = false;
            return _context2.finish(29);
          case 32:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[11, 26, 29, 32]]);
    })));
    return {
      __sfc: true,
      route: route,
      router: router,
      $auth: $auth,
      loading: loading,
      errorMessage: errorMessage,
      successMessage: successMessage,
      accountId: accountId,
      acceptInvite: acceptInvite,
      title: title,
      continueTo: continueTo,
      waitForAuthReady: waitForAuthReady
    };
  }
});